import { api } from "../../utils/api";

export const getSimulations = async (id, data) => {
  try {
    const response = await api.get(
      `/sale-simulation?enterprise_id=${id}`,
      data && { params: data }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
